import { LinkCategoryInsert, LinkCategoryDelete, LinkCategoryUpdate, LinkCategoryGetById, LinkCategoryGetList, LinkCategoryGetPageList } from "@/api/linkcategory/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    LinkCategoryInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            LinkCategoryInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    LinkCategoryUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            LinkCategoryUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    LinkCategoryGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            LinkCategoryGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    LinkCategoryGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            LinkCategoryGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    LinkCategoryGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            LinkCategoryGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}